<script>
import { nomeRentabilidades } from '@constants/Text'
import {
  CLIENT_BENCHMARK_KEY,
  formatBenchmarkRelativeLabel,
} from '@utils/clienteBenchmark'

export default {
  props: {
    rentabilidadesAll: {
      type: Object,
      default: () => {
        return {
          ipca: {},
          rentabilidade_relativo: {},
          rentabilidade: { mes: '' },
        }
      },
    },
    benchmarksSelecionados: {
      type: Array,
      default: () => [],
    },
    rentabilidadesBenchmarks: {
      type: Object,
      default: () => ({}),
    },
    // Metadata do benchmark personalizado do cliente (label + logic).
    // Necessário para exibir o nome correto na linha 'cliente_benchmark'.
    clienteBenchmarkMeta: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      mapRentabilidades: nomeRentabilidades,
    }
  },
  computed: {
    mapBenchmarks() {
      return this.$store.getters['settings/benchmarks'].reduce((acc, v) => {
        acc[v.id] = v.nome
        return acc
      }, {})
    },
    comparisonBenchId() {
      const isPersonalizado =
        this.rentabilidadesAll.benchmark_relativo === CLIENT_BENCHMARK_KEY
      if (isPersonalizado && this.clienteBenchmarkMeta) {
        return this.benchmarksSelecionados.includes(CLIENT_BENCHMARK_KEY)
          ? CLIENT_BENCHMARK_KEY
          : null
      }
      return (
        Object.keys(this.mapBenchmarks).find(
          (id) => this.mapBenchmarks[id] === 'CDI'
        ) || null
      )
    },
    comparisonLabel() {
      return formatBenchmarkRelativeLabel(this.clienteBenchmarkMeta)
    },
    // Há dados de rentabilidade para exibir? Tira o Object.entries do template e
    // protege contra rentabilidadesAll degradado (sem a chave `rentabilidade`),
    // que antes quebrava o render com Object.entries(undefined).
    temRentabilidade() {
      const rent = this.rentabilidadesAll && this.rentabilidadesAll.rentabilidade
      return !!(rent && Object.keys(rent).length)
    },
  },
}
</script>

<template>
  <div class="tabela-rent-benchmark">
    <table class="table-new-ux-v1 tabela-dados tabela-retornos text-left">
      <thead>
        <tr>
          <th class="border-bottom-thead"></th>
          <th> Mês </th>
          <th> Ano </th>
          <th> 12 meses </th>
          <th> Data </th>
          <th> Início </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="temRentabilidade">
          <td>
            <strong>Rentabilidade</strong>
          </td>
          <td>
            <strong>{{ rentabilidadesAll.rentabilidade.mes || '-' }}</strong>
          </td>
          <td>
            <strong>{{ rentabilidadesAll.rentabilidade.ano || '-' }}</strong>
          </td>
          <td>
            <strong>{{ rentabilidadesAll.rentabilidade['12M'] || '-' }}</strong>
          </td>
          <td>
            <strong>{{
              rentabilidadesAll.rentabilidade.data_inicio ||
              rentabilidadesAll.data_inicio ||
              '-'
            }}</strong>
          </td>
          <td>
            <strong>{{ rentabilidadesAll.rentabilidade.inicio || '-' }}</strong>
          </td>
        </tr>
        <tr v-for="benchId in benchmarksSelecionados" :key="benchId">
          <template v-if="benchId === comparisonBenchId">
            <td>
              <span
                class="d-inline-flex align-center"
                :class="{ 'cb-label': benchId === 'cliente_benchmark' }"
              >
                {{ comparisonLabel }}
                <v-tooltip bottom max-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" class="ml-1 d-inline-flex" v-on="on">
                      <icon-svg name="info-circle" :size="14" />
                    </span>
                  </template>
                  <span>
                    Desempenho da carteira em relação ao benchmark de referência
                    do cliente no período.
                  </span>
                </v-tooltip>
              </span>
            </td>
            <td>
              {{ rentabilidadesAll.rentabilidade_relativo.mes || '-' }}
            </td>
            <td>
              {{ rentabilidadesAll.rentabilidade_relativo.ano || '-' }}
            </td>
            <td>
              {{ rentabilidadesAll.rentabilidade_relativo['12M'] || '-' }}
            </td>
            <td>
              {{
                rentabilidadesAll.rentabilidade_relativo.data_inicio ||
                rentabilidadesAll.data_inicio ||
                '-'
              }}
            </td>
            <td>
              {{ rentabilidadesAll.rentabilidade_relativo.inicio || '-' }}
            </td>
          </template>
          <template v-else-if="benchId === 'cliente_benchmark' && clienteBenchmarkMeta">
            <td>
              <span class="cb-label">
                {{ clienteBenchmarkMeta.label || 'Meu Benchmark' }}
              </span>
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId].mes || '-'
                  : '-'
              }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId].ano || '-'
                  : '-'
              }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId]['12M'] || '-'
                  : '-'
              }}
            </td>
            <td>
              {{ rentabilidadesAll.data_inicio || '-' }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId]['inicio'] || '-'
                  : '-'
              }}
            </td>
          </template>
          <template v-else>
            <td>
              {{ mapBenchmarks[benchId] }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId].mes
                  : '-'
              }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId].ano
                  : '-'
              }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId]['12M']
                  : '-'
              }}
            </td>
            <td>
              {{ rentabilidadesAll.data_inicio || '-' }}
            </td>
            <td>
              {{
                rentabilidadesBenchmarks[benchId]
                  ? rentabilidadesBenchmarks[benchId]['inicio']
                  : '-'
              }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.cb-label {
  color: #C9A961;
  font-weight: 500;
}
</style>


